export default {
    common: {
        company: 'Selskap',
        companyTitle: 'Peab',
        confirmDialog: 'Er du sikker på at du vil tilbakestille passordet?',
        country: 'Norge',
        createNewPassword: 'Opprett nytt passord',
        description: 'Har du glemt passordet eller er kontoen låst? Velg selskap, skriv inn ansattnummer og klikk på Send.',
        identificationNumber: 'Ansattnummer',
        passwordReset: 'Opprett nytt passord',
        placeholderidentificationNumber: 'Skriv inn ansattnummer',
        reset: 'Tilbakestille',
        resetSuccess: 'Ditt passord er gjenopprettet',
        title: 'Password reset',
        settings: 'Innstillinger',
        enterInformation: 'Fyll ut detaljene',
        passwordIsReset: 'Reset passord',
        return: 'Tilbake',
        sweden: 'Sverige',
        norway: 'Norge',
        finland: 'Suomi',
        passwordSent: 'Et nytt passord er sendt til deg via tekstmelding.',
        siteErrorInfoHeader: 'Tjenesten er stengt.',
        siteErrorInfoText: 'Vi anbefaler å bruke https://aka.ms/SSPR eller kontakte IT-støtte på 21 52 11 21 eller via supportportalen for å få hjelp.'
    },
    errormessages: {
        majorError: 'Noe gikk galt',
        pageNotFound: 'Siden kan ikke bli funnet',
    }
};
